import { AccessLevelDisplayNames } from "@components/access-level/access-level-utils";
import { ListItemCardMobile } from "@components/common/mobile/list-item-card-mobile";
import { MenuItemOption } from "@components/common/mobile/mobile-types";
import { BaseSnapshotProps, Snapshot } from "@custom-types/base-types";
import { NO_TRANSLATE_CLASS, Text } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
import { SNAPSHOTS_TABLE_COLUMN_LABELS } from "@pages/project-details/project-snapshots/snapshots-table-constants";
import { withEllipsis } from "@styles/common-styles";

interface Props extends BaseSnapshotProps {
  /** Optional callback triggered when the card is clicked. */
  onCardClick?: () => void;

  /** Optional menu options; when provided a three-dots menu is shown. */
  menuItems?: MenuItemOption<Snapshot>[];
}

/**
 * @returns A card with information of the passed snapshot for the snapshot list in mobile view.
 */
export function SnapshotListItemCardMobile({
  snapshot,
  onCardClick,
  menuItems,
}: Props): JSX.Element {
  const { formatDateWithTooltip } = useDateTime();
  const { displayDate, tooltipDate } = formatDateWithTooltip(
    snapshot.createdAt
  );

  const accessLevel = AccessLevelDisplayNames[snapshot.accessLevel];

  return (
    <ListItemCardMobile<Snapshot>
      item={snapshot}
      // All snapshots have same thumbnail which is from project, Not showing instead of repetitive thumbnail for all snapshots
      image={null}
      title={
        <Text
          variant="heading14"
          sx={{ ...withEllipsis }}
          className={NO_TRANSLATE_CLASS}
        >
          {snapshot.name}
        </Text>
      }
      onCardClick={onCardClick}
      subtitle={
        <Text variant="bodyS">
          {SNAPSHOTS_TABLE_COLUMN_LABELS.created}
          <span className={NO_TRANSLATE_CLASS}>: {displayDate}</span>
        </Text>
      }
      subtitleTooltip={tooltipDate ? <var>{tooltipDate}</var> : undefined}
      secondaryText={accessLevel}
      menuItems={menuItems}
    />
  );
}
